module.exports = __webpack_public_path__ + "static/media/WebDev-md_1x.67742861.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/WebDev/WebDev-md_1x.jpg
// module id = 767
// module chunks = 0